import { disabledClareStatus, enabledClareStatus } from "@app/shared/model/clare-status.model";
import { SceneCommand, SceneCommandHelper, isSceneCommand } from "./commands/scene-command";

import { ImportMap } from "@app/shared/resources/class-importer-exporter.service";
import { ConditionType } from "./conditions";

export interface CHRuleInt {
    ruleId: string;
    name: string;
    commandId: string;
    commandType: string;
    conditionId: string;
    conditionType: string;
    active: boolean;
    properties: Record<string, unknown>;
    createdByMch: boolean;
    internal: boolean;
    command: SceneCommand;
    condition: ConditionType;
    activationStatus?;
    type?;
}

/* eslint-disable @typescript-eslint/naming-convention */
export interface CHRuleData {
    rule_id: string;
    name: string;
    command_id: string;
    command_type: string;
    condition_id: string;
    condition_type: string;
    active: boolean;
    properties: Record<string, unknown>;
    created_by_mch: boolean;
    internal: boolean;
    command: SceneCommand;
    condition: ConditionType;
}
/* eslint-enable @typescript-eslint/naming-convention */

export class CHRule implements CHRuleInt {
    command: SceneCommand;
    condition: ConditionType;
    ruleType: string;

    static readonly importMap: ImportMap<CHRuleInt, CHRuleData> = [
        { i: "rule_id", o: "ruleId" },
        { i: "name", o: "name" },
        { i: "command_id", o: "commandId" },
        { i: "command_type", o: "commandType" },
        { i: "condition_id", o: "conditionId" },
        { i: "condition_type", o: "conditionType" },
        { i: "active", o: "active" },
        { i: "properties", o: "properties" },
        { i: "created_by_mch", o: "createdByMch" },
        { i: "internal", o: "internal" },
        { i: "condition", o: "condition" },
        { i: "command", o: "command" },
    ];

    static fromCHObject(rule: any): CHRule {
        return new CHRule(
            rule[CHRule.importMap[0].i],
            rule[CHRule.importMap[1].i],
            rule[CHRule.importMap[2].i],
            rule[CHRule.importMap[3].i],
            rule[CHRule.importMap[4].i],
            rule[CHRule.importMap[5].i],
            rule[CHRule.importMap[6].i],
            rule[CHRule.importMap[7].i],
            rule[CHRule.importMap[8].i],
            rule[CHRule.importMap[9].i]
        );
    }

    constructor(
        public ruleId: string,
        public name: string,
        public commandId: string,
        public commandType: string,
        public conditionId: string,
        public conditionType: string,
        public active: boolean,
        public properties: Record<string, unknown>,
        public createdByMch: boolean,
        public internal: boolean = false
    ) {
        this.type = this.conditionType;
    }

    get activationStatus() {
        if (!this.active) {
            return disabledClareStatus;
        }
        return enabledClareStatus;
    }

    get type(): string {
        return this.ruleType;
    }

    set type(conditionType: string) {
        switch (conditionType) {
            case "AbsoluteTimerCondition":
            case "PeriodTimerCondition":
            case "IntervalTimerCondition":
            case "DailyTimerCondition":
            case "AstroTimerCondition":
                this.ruleType = "Schedule";
                break;

            case "UICondition":
                this.ruleType = "Button Scene";
                break;

            case "MultiCondition":
            case "PropertyChangeCondition": {
                if (isSceneCommand(this.command) && SceneCommandHelper.hasOnlyNotificationCommands(this.command)) {
                    this.ruleType = "Notification";
                } else {
                    this.ruleType = "Automation";
                }
                break;
            }

            default:
                this.ruleType = this.conditionType;
        }
    }
}
